import './assets/main.scss';

import { createApp } from 'vue';
import App from './App.vue';
import type { QuizData } from '@vue-quiz-app/types/quiz';

declare const quizData: QuizData | undefined; // The variable is taken from other script tag

const app = createApp(App);
app.provide('quizData', quizData);
app.mount('#quiz-app');
